import { version } from "../package.json";

import { PUBLIC_ASSETS_PATH } from "@szgc/plt-core-v2";

import { add_xml_http_request_header, remove_xml_http_request_header } from "./XMLHttpRequest";

window.wbenchVersion = version;

export { default as SzgcFormGetor } from "../gt/package/SzgcFormGetor/index.vue";
export { default as SzgcProcessGetor } from "../pt/package/SzgcProcessGetor/index.vue";
export { default as SzgcMobileGetor } from "../mobile/package/SzgcMobileGetor/index.vue";
export { default as SzgcWbench } from "@/package/components/szgc-wbench/index.vue";
export { default as SzgcReadGetor } from "../gt/package/Read/index.vue";

export { default as SzgcModelView } from "../model-view/package/SzgcFormTable/index.vue";

export { install_kinggrid } from "../gt";
export { ntko_addon } from "../gt";

export { NtkoSign } from "../gt";

export { ContractLock } from "../gt";

(() => {
  const script = document.createElement("script");
  script.src = PUBLIC_ASSETS_PATH + "ntko/rh_h5_sdk/document-viewer.js";
  document.body.appendChild(script);
})();

/**
 * 导出流程表单数据到pdf文件
 * @param businessId
 */
export function exportProcessToPdf(businessId: string) {
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = `/api/appproc/templates/export/${businessId}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * 为所有的XMLHttpRequest添加请求头
 * @param header 请求头对象
 */
export const add_request_header = add_xml_http_request_header;

/**
 * 为所有的XMLHttpRequest移除请求头
 * @param keys 需要移除的请求头key数组
 */
export const remove_request_header = remove_xml_http_request_header;

window["Signature"] = false;

window.exportProcessToPdf = exportProcessToPdf;

